import { Affix, BackTop, Button, Icon, Input, Modal, Table } from "antd";
import { get } from "lodash";
import * as React from "react";
import { IPortalApplicant } from "../../../model/applicant/PortalApplicant";
import { IPortalFormPresentationModel } from "../../../model/form/PortalFormPresentationModel";
import { TTranslate } from "../../../service/locale/TranslationService";
import FormListModal from "./FormListModal";
import MobileApplicantSearchModal from "./MobileApplicantSearchModal";
import Highlighter from "react-highlight-words";
import { IReportingPeriodApplicantDocument } from "../../../model/document/ReportingPeriodApplicantDocument";

export interface State {
  formListModalVisible: boolean;
  applicantSearchVisible: boolean;
  searchApplicantInfo?: IPortalApplicant;
  formListLoading: boolean;
}

export interface Props {
  columns: any[];
  translate: TTranslate;
  applicants: IPortalApplicant[];
  className?: string;
  selectedApplicantForms: IPortalFormPresentationModel[];
  onApplicantSelect: (applicant: IPortalApplicant) => Promise<void>;
  showFormDetails: (id: number) => void;
  documents?: IReportingPeriodApplicantDocument[];
}

export default class MobileReportingPeriodApplicantsTable extends React.Component<
  Props,
  State
> {
  constructor(props: any) {
    super(props);
    this.state = {
      formListModalVisible: false,
      applicantSearchVisible: false,
      formListLoading: false
    };
  }

  showFormListModal = () => {
    this.setState({ formListModalVisible: true });
  };

  hideFormListModal = () => {
    this.setState({ formListModalVisible: false });
  };

  showApplicantSearch = () => {
    this.setState({ applicantSearchVisible: true });
  };

  hideApplicantSearch = () => {
    this.setState({ applicantSearchVisible: false });
  };

  setSearchApplicantInfo = (searchApplicantInfo?: IPortalApplicant) => {
    this.setState({ searchApplicantInfo });
  };

  render() {
    const {
      translate,
      applicants,
      className,
      selectedApplicantForms,
      onApplicantSelect,
      showFormDetails,
      documents
    } = this.props;

    let { columns } = this.props;

    const {
      formListModalVisible,
      applicantSearchVisible,
      searchApplicantInfo,
      formListLoading
    } = this.state;

    columns = columns.map((column) => {
      if (column.dataIndex === "firstName" || column.dataIndex === "lastName") {
        return {
          ...column,
          fixed: "left"
        };
      }
      return column;
    });

    columns = columns.map((column) => {
      return {
        ...column,
        sorter:
          column.key !== "actions" && !column.sorter
            ? (a, b) =>
                (String(get(a, column.dataIndex)) || "").localeCompare(
                  String(get(b, column.dataIndex)) || ""
                )
            : column.sorter ?? undefined,
        sortDirections: ["descend", "ascend"]
      };
    });

    columns = columns.map((column) => {
      return {
        ...column,
        filteredValue: searchApplicantInfo
          ? [searchApplicantInfo[column.dataIndex]] || null
          : null,
        onFilter: (value, record) => {
          let cellValue = get(record, column.dataIndex);

          if (cellValue !== 0 && !cellValue) {
            cellValue = "";
          }

          return cellValue
            .toString()
            .toLowerCase()
            .includes((value || "").toLowerCase());
        },
        render: (text) => {
          if (text || text === 0) {
            return searchApplicantInfo &&
              searchApplicantInfo[column.dataIndex] ? (
              <Highlighter
                highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
                searchWords={[searchApplicantInfo[column.dataIndex]]}
                autoEscape
                textToHighlight={text.toString()}
              />
            ) : (
              text
            );
          }
        }
      };
    });

    return (
      <div>
        <Affix className={"mobile-search-btn"}>
          <Button
            type={searchApplicantInfo ? "primary" : "default"}
            icon={"search"}
            onClick={() => {
              this.showApplicantSearch();
            }}
            style={{ width: "50px", height: "50px", borderRadius: "50%" }}
          ></Button>
        </Affix>
        <Table
          locale={{ emptyText: translate("data_grid.empty_text") }}
          size={"middle"}
          className={className}
          columns={columns}
          dataSource={applicants}
          pagination={{
            simple: true,
            defaultPageSize: 10,
            position: "bottom"
          }}
          scroll={{ x: true }}
          onRow={(record, rowIndex) => {
            return {
              onClick: async (event) => {
                this.setState({ formListLoading: true });
                this.showFormListModal();
                await onApplicantSelect(record);
                this.setState({ formListLoading: false });
              }
            };
          }}
        />
        <FormListModal
          visible={formListModalVisible}
          onCancel={this.hideFormListModal}
          translate={translate}
          forms={selectedApplicantForms}
          loading={formListLoading}
          showFormDetails={showFormDetails}
          documents={documents}
        />
        <MobileApplicantSearchModal
          columns={columns}
          visible={applicantSearchVisible}
          onCancel={this.hideApplicantSearch}
          translate={translate}
          setSearchApplicantInfo={this.setSearchApplicantInfo}
        />
      </div>
    );
  }
}
